import React, { useMemo } from 'react';
import { DownloadIcon, Share2Icon, Cross2Icon, TrashIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { download } from '../../../lib/utils/download';
import { ShareModal } from '../../share/components/share-modal';
import { useSelection } from '../../../core/contexts/selection.context';
import { Asset } from '../../../app/entities';
import { DeleteDialog } from '../../../components/dialogs/DeleteDialog';
import { openModal } from '../../../core/modal/open-modal';

import styles from './action-bar.module.scss';
type ActionBarProps = {
  spaceId: string;
  projectId: string;
};

export const ActionBar: React.FC<ActionBarProps> = ({ projectId, spaceId }) => {
  const { elements, clear } = useSelection();

  const [areLinksSelected, idsToHandle] = useMemo(() => {
    const assets = elements.map((id) => Asset.getOne(id)).filter((el) => !!el) as Asset[];
    const areLinksSelected = assets.every((el) => el.type === 'link');
    const idsToHandle = assets.filter((el) => el.type !== 'link').map((el) => el._id);

    return [areLinksSelected, idsToHandle];
  }, [elements]);

  const downloadAllAssets = async () => {
    if (!idsToHandle.length) return;

    for (const id of idsToHandle) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      download(id);
    }
  };

  const deleteFiles = async () => {
    if (!elements.length) return;
    await Asset.deleteMany(elements);
  };

  if (!elements.length) {
    return null;
  }

  const openShareModal = () =>
    openModal(ShareModal, {
      elementIds: elements,
      spaceId,
      projectId,
    });

  const openDeleteModal = () =>
    openModal(DeleteDialog, {
      title: 'Delete files',
      text: 'Are you sure you want to delete the selected files?',
      onSubmit: deleteFiles,
    });

  return (
    <div className={styles['container']}>
      <div className={styles['actions']}>
        <IconButton icon={<Cross2Icon />} onClick={clear} variant="default" />
        <IconButton icon={<TrashIcon className={styles['custom-trash-can']} />} onClick={openDeleteModal} variant="default" />
      </div>

      <p>
        {elements.length} selected file{elements.length > 1 && 's'}
      </p>

      <div className={styles['actions']}>
        <IconButton icon={<Share2Icon />} onClick={openShareModal} variant={'primary'} />
        <IconButton
          icon={<DownloadIcon />}
          onClick={downloadAllAssets}
          variant={'primary'}
          disabled={areLinksSelected}
        />
      </div>
    </div>
  );
};

